import NoDataRow from '@/platform/common/components/NoDataRow/NoDataRow';
import { localDate } from '@/platform/lib/utils';
import {
    Badge,
    Container,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Segment,
    SegmentContent,
    SegmentHeader,
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@/platform/ui';
import { EllipsisVerticalIcon, EyeIcon } from '@heroicons/react/24/outline';
import { usePage } from '@inertiajs/react';

const IndexView = () => {
    const { auth, mail_logs } = usePage().props;

    const previewUrl = log =>
        `/customers/${auth.customer.id}/logs/${log.batch}`;

    return (
        <Container>
            <Segment>
                <SegmentHeader
                    header='Logboek'
                    subheader='Hieronder tref je de verzonden berichten aan. Door op de knop bekijken te klikken zie je ook het gehele bericht.'
                />
                <SegmentContent>
                    <Table striped>
                        <TableHeader>
                            <TableRow>
                                <TableHeaderCell>
                                    Contactpersoon
                                </TableHeaderCell>
                                <TableHeaderCell>Actie</TableHeaderCell>
                                <TableHeaderCell>Datum</TableHeaderCell>
                                <TableHeaderCell>Status</TableHeaderCell>
                                <TableHeaderCell
                                    className='w-px'
                                    textAlign='right'
                                />
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {mail_logs?.length === 0 && (
                                <NoDataRow numberOfColumns={5} />
                            )}

                            {mail_logs?.map(log => (
                                <TableRow key={log.batch}>
                                    <TableCell>{log.contact.name}</TableCell>
                                    <TableCell>
                                        Reminder verzonden:{' '}
                                        {log.actions.join(', ')}
                                    </TableCell>
                                    <TableCell singleLine>
                                        {localDate(log.date)}
                                    </TableCell>
                                    <TableCell>
                                        {log.is_future ? (
                                            <Badge color='gray'>Gepland</Badge>
                                        ) : (
                                            <Badge color='green'>
                                                Verzonden
                                            </Badge>
                                        )}
                                    </TableCell>
                                    <TableCell
                                        className='w-px'
                                        singleLine
                                        textAlign='right'
                                    >
                                        <Menu>
                                            <MenuButton
                                                aria-label={`Acties voor ${log.contact.name}`}
                                            >
                                                <EllipsisVerticalIcon className='size-5' />
                                            </MenuButton>
                                            <MenuItems anchor='bottom end'>
                                                <MenuItem
                                                    as='a'
                                                    href={previewUrl(log)}
                                                    target='_blank'
                                                    rel='noreferrer'
                                                    icon={EyeIcon}
                                                >
                                                    Bekijken
                                                </MenuItem>
                                            </MenuItems>
                                        </Menu>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </SegmentContent>
            </Segment>
        </Container>
    );
};

export default IndexView;
